import { CYNCLYItemsMetadata } from "./cyncly_items_metadata/cyncly-items-metadata";
import { CYNCLYLightsMetadata } from "./cyncly_lights_metadata/cyncly-lights-metadata";
import { CYNCLYMaterialsMetadata } from "./cyncly_materials_metadata/cyncly-materials-metadata";
import { CYNCLYMeshMetadata } from "./cyncly_mesh_metadata/cyncly-mesh-metadata";
import { EXTLightsIES } from "./ext_lights_ies/lights-ies";

export const CYNCLY_EXTENSIONS = [
    CYNCLYItemsMetadata,
    CYNCLYLightsMetadata,
    CYNCLYMaterialsMetadata,
    CYNCLYMeshMetadata,
    EXTLightsIES,
];

export * from "./cyncly_items_metadata/index";
export * from "./cyncly_lights_metadata/index";
export * from "./cyncly_materials_metadata/index";
export * from "./cyncly_mesh_metadata/index";
export * from "./ext_lights_ies/index";